export const AppHolder = {
  bus: null,
  store: null
}
